import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionalComponent } from './conditional.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ConditionalComponent],
  exports: [ConditionalComponent],
})
export class SharedUiConditionalModule {}
